export const getFreeSubscriptions = () => {
  const subscriberGroups = localStorage.getItem(
    "KLOUSER_SUBSCRIBED_GROUPS"
  );
  return !!subscriberGroups ? JSON.parse(subscriberGroups) : [];
};